import { EyeOutlined } from '@ant-design/icons';
import * as Antd from 'antd';
import {
    Link,
    type To,
} from 'react-router-dom';

import { getActionControlStyleVars } from './actionControlStyles';

type ActionViewButtonProps = {
    onClick: React.MouseEventHandler<HTMLElement>;
    disabled?: boolean;
    text?: string;
    to?: To;
};

export const ActionViewButton = ({
    onClick,
    disabled,
    text,
    to,
}: ActionViewButtonProps) => {
    const { token } = Antd.theme.useToken();
    const label = text ?? 'Переглянути';
    const iconOnly = !text;
    const styleVars = getActionControlStyleVars(token, {
        variant: 'text',
        bordered: true,
        iconOnly,
        disabled,
    });
    const icon = <EyeOutlined style={{ fontSize: 16 }} />;
    const labelNode = text ? (
        <span style={{ color: token.actionViewBtnColorText, fontWeight: 400 }}>
            {label}
        </span>
    ) : null;

    if (to && !disabled) {
        return (
            <Antd.Tooltip title={label}>
                <Link
                    to={to}
                    aria-label={label}
                    className={`app-action-control${iconOnly ? ' app-action-control--icon' : ''}`}
                    style={styleVars}
                >
                    {icon}
                    {labelNode}
                </Link>
            </Antd.Tooltip>
        );
    }

    return (
        <Antd.Tooltip title={label}>
            <Antd.Button
                type="text"
                className={`app-action-control${iconOnly ? ' app-action-control--icon' : ''}`}
                style={styleVars}
                icon={icon}
                onClick={onClick}
                disabled={disabled}
            >
                {labelNode}
            </Antd.Button>
        </Antd.Tooltip>
    );
};
